import React, { useEffect,useState } from 'react'
import {Form , DatePicker,Switch, Button, Input, Upload, Image, Row, Col, Space} from 'antd'
import {updateEvents, eventsSelector, fetchOneEvents} from '../../api/events'
import { useDispatch, useSelector } from 'react-redux';
import {useParams} from 'react-router-dom'
import Loader from '../../shared/loaderImg';
import storage from '../../shared/storage'
import { MdDelete} from 'react-icons/md'
import styled from 'styled-components'
import { LoadingOutlined, PlusOutlined,MinusCircleOutlined } from '@ant-design/icons';
import ReactQuill from 'react-quill';
import moment from 'moment'
import {useHistory} from "react-router-dom";
import '../../../index.css'
import ModalForm from '../../shared/modal';
import { nanoid } from '@reduxjs/toolkit'
import EventTable from './eventTable'
import PressRelease from './PressImageTable'



export default function EditEvents() {


  
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const [form3] = Form.useForm();
const history = useHistory();
const [visibleEdit, setVisibleEdit] = useState(false)
const [uploadDone,setUploadDone] = useState(false)
const dispatch = useDispatch()
const {currentevents, loading} = useSelector(eventsSelector)
const [form] = Form.useForm();
const [imgurl, setImgurl] = useState([])
const [eventimage, setEventImage] = useState([])
const [loading1, setLoading1] = useState(false)
const [loading2, setLoading2] = useState(false)
const [FeaturedImage,setFeaturedImage] = useState([])
const [deletedEvents, setDeletedevents] = useState([])
const [addField,setAddField] = useState(false)
const [eId,setId] = useState(0)
const [button, setButton] = useState('save')

const [fileList, setFileList] = useState([])
const [checked, setChecked] = useState();
const {id} = useParams()

const [event, setEvent] = useState("");



// Event gallery starts here
const [visibleFeatureImageEdit, setFeatureImageEdit] = useState(false)
const [PressButton, setPressButton] = useState('save')
const [uploadPressReleaseDone, setUploadPressReleaseDone] = useState(false)
const [deletedPressEvents, setDeletedPressevents] = useState([])
const [addPressReleaseField,setAddPressRelease] = useState(false)
const [pId,setPid] = useState(0)
 

console.log({FeaturedImage})
const add = () => {
  setAddField(true)
 
  setId(nanoid())
}

const addPressReleaseImage = ()=>{
  setAddPressRelease(true)
  setPid(nanoid())

}

const onAddPressRelease = (values) =>{
  if(button === 'save'){
    console.log("Its save button")
    //  setVisibleEdit(false)
    
    setAddPressRelease(false)
    setPid(null)
    form3.resetFields()
    
  }
  setUploadPressReleaseDone(true)
  // console.log({FeaturedImage})


}

const handleClickPressDelete = (id) =>{
  const newPressRelease = FeaturedImage.filter(item =>{
    return item.pId !== id.pId
  })
  setDeletedPressevents([...FeaturedImage,id])
  setFeaturedImage(newPressRelease)
  setAddPressRelease(false)
}

const uploadPressReleaseFile = (info) =>{
  setLoading1(true)
  
  storage
  .ref("images/" + info.file.name)
  .put(info.file.originFileObj)
  .then(snapshot => {
    return snapshot.ref.getDownloadURL();
  })
  .then(url => {
   setFeaturedImage([...FeaturedImage, {image:url,caption:null,pId}])
    console.log({FeaturedImage})
    setLoading1(false)
  })
  .catch(error => {
    console.log({error});
  });

}
const onPressReleaseCaption = (e,key)=>{
  FeaturedImage.map((item)=>{
    if(item.pId == key)
        return item.caption = e.target.value
    else
     return item
  })
}

const removePressReleaseEvent = ()=>{
  setAddPressRelease(false)
  form3.resetFields()
}

const handleClickDelete = (id) => {  
  const newPartArr = eventimage.filter(item => {
    console.log(id)
      return item.eId !== id.eId
  })      
  
  setDeletedevents([...deletedEvents, id])
  setEventImage(newPartArr)
  setAddField(false)
  // message.success('Part Deleted')
}



    useEffect(()=>{
        dispatch(fetchOneEvents(id))
        
    }, [id])

    
    const onCaption = (e,key)=>{
        console.log(e)
        console.log(key)
        FeaturedImage.map((item,i)=>{
          console.log(item)
          if(item.key == key)
            return item.caption = e.target.value
          else
          return item
        })
  
        // e.preventDefault()
        // // setFeaturedImage({...FeaturedImage, [e.target.name]: e.target.value });
        // FeaturedImage.caption = e.target.value
        // setFeaturedImage([{...FeaturedImage}])
      }
      const onEventCaption = (e,key)=>{
        console.log({eventimage})
        eventimage.map((item,i)=>{
         
          if(item.eId == key)
             return item.caption = e.target.value
            
          else
             return item
        })
      }
      const uploadFeaturedFile = (value,key)=>{
        setLoading2(true)
        console.log("The complete object of featured image",value)
        
        let newfileList = [...value.fileList]
        newfileList = newfileList.map((item)=>{
            console.log(item)
       
           
            storage
            .ref("images/" + item.name)
            .put(item.originFileObj)
            .then(snapshot => {
                return snapshot.ref.getDownloadURL();
            })
        
            .then(url => {
                console.log(url);
                 
                setFeaturedImage([...FeaturedImage,{image:url,caption:null,key}])

                setLoading2(false)
                console.log("Featured Image URL is",FeaturedImage)                
            })
            .catch(error => {
                console.log("error in code")
                console.log({error});
            });
           
           
        })
        
        
    }
    const removefeatureImage = (e, url) =>{
    
        setFeaturedImage(prev => prev.filter(item => item !== url))
        
        }
        const onAddPart = (values) => {
          setUploadDone(true)
          if(button === 'save'){
            console.log("Its save button")
            //  setVisibleEdit(false)
          
            setAddField(false)
             setId(null)
        form2.resetFields()
            
          }
           console.log({eventimage})
        }
        const removeEvent = ()=>{
          setAddField(false)
          form2.resetFields()
        }


    useEffect(()=>{
      setImgurl([currentevents?.image]);
      setEventImage([currentevents?.event_images])
      // setFeaturedImage(currentevents?.featured_images)
    //   setEventImage([])
      // currentevents?.event_images?.map((item)=>{

      //   return setEventImage([...eventimage,item])
      // })

               

      

        currentevents?.event_images && setEventImage(currentevents?.event_images)
        currentevents?.featured_images && setFeaturedImage(currentevents?.featured_images)
      
      console.log(currentevents?.event_images)

      form1.setFieldsValue({
            title: currentevents && currentevents.title,     
            sub_title: currentevents && currentevents.sub_title,
            description: currentevents && currentevents.description,
            // date:currentevents && moment(currentevents?.date),
          
        event_images:currentevents && currentevents?.event_images,
        featured_images:currentevents && currentevents?.featured_images,
            // event_images:currentevents && currentevents.event_images
          })
          form2.setFieldValue({
            image:eventimage?.image,
            caption:eventimage.caption,
            eId:eventimage.eId,

          })
          form3.setFieldValue({
            image:FeaturedImage.image,
            caption:FeaturedImage?.caption,
            pId:FeaturedImage?.pId,
          })
          

    }, [currentevents])

    console.log(currentevents?.date)





      const onFinish = (values) => {

        console.log(moment(values.date).format('L'))
        const data = {
            title:values.title,
            image: imgurl.length>=1 ? imgurl[0] : null,
            sub_title:values.sub_title , 
            date:values.date,
            description:event,
            event_images:eventimage
        }

        console.log(data)
        dispatch(updateEvents(id, data))
        history.goBack()
        
        
      };
        
        const onFinishFailed = (errorInfo) => {
          console.log('Failed:', errorInfo);
        };



        const uploadFile = (info)=>{
          console.log(info)
          
          setLoading1(true)
         
          storage
          .ref("images/" + info.file.name)
          .put(info.file.originFileObj)
          .then(snapshot => {
            return snapshot.ref.getDownloadURL();
          })
          .then(url => {
            setEventImage([...eventimage, {image:url,caption:null,eId}])
            console.log({eventimage})
            setLoading1(false)
          })
          .catch(error => {
            console.log({error});
          });
        }
  

            const handleChange = info => {
              setLoading1(true)
                 
                  storage
                  .ref("images/" + info.file.name)
                  .put(info.file.originFileObj)
                  .then(snapshot => {
                    return snapshot.ref.getDownloadURL();
                  })
                  .then(url => {
                    console.log(url);
                    setImgurl([...imgurl, url])
                   
                    setLoading1(false)
              
                  })
                  .catch(error => {
                    console.log(error);
                  });
              
                };
          
        
            const remove = (e, url) =>{
        
              setImgurl(prev => prev.filter(item => item !== url))
              
              }
              const removeeventImage = (e, url) =>{
        
                setEventImage(prev => prev.filter(item => item !== url))
                
                }
        
              const uploadButton = (
                  <div>
                    { loading1 ? <LoadingOutlined  /> : <PlusOutlined />}
                    <div style={{ marginTop: 8, fontSize:"14px" }}>{loading1 ? "uploading" :""}</div>
                  </div>
                );



                const layout = {
                  labelCol: {
                    span: 5,
                  },
                  wrapperCol: {
                    span: 16,
                  },
                };
                const tailLayout = {
                  wrapperCol: {
                    offset: 4,
                    span: 16,
                  },
                };
     
                
                const modules = {
                  toolbar: [
                    [{ 'font': [] }],
                    [{size: []}],
                    ['bold', 'italic', 'underline','strike', 'blockquote'],
                    [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
                    ['link', 'image'],
                    ['clean']
                  ],
                }
              
                const formats = [
                  'header', 'font', 'size',
                  'bold', 'italic', 'underline', 'strike', 'blockquote',
                  'list', 'bullet', 'indent',
                  'link', 'image'
                ]
          
                  

    return (
        <FormWrap>     
        <div>
              <h5 className="">Update Events</h5>
              <hr style={{height:"0.1rem"}} className="mb-5 mt-3 bg-light border-0"/>


       <Form
          name="basic"
           {...layout}
            form={form1}

 
      initialValues={{ remember: true }}
    
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >


<Form.Item
        label="Title"
        name="title"
      >
        <Input className=" text-capitalize"  />
      </Form.Item>


     
      <Form.Item
        name="Image"
        label="Banner Image"
      >
      

          <Row gutter={10}>
            <Col span={5}>
                {

                imgurl?.map((img, i)=>{

                  return <div className=" imglist " style={{height:"100px"}}>
                   
                  <Image    
                   preview={false}               
                   key={i}
                   style={{height:"100%", width:"100%", borderRadius: '0.25rem', display:'block', objectFit:'cover'}}
                   src={img}
                   placeholder={<Loader/> }              
                 />   

                  <h2 onClick={(e)=>remove(e, img)} className=" text-white  "> <MdDelete/></h2> 

                    </div>
                })
              }
              </Col>

                <Upload       
                        listType="picture-card"
                        fileList={fileList}
                        onChange={handleChange}
                        multiple={true}
                        style={{marginLeft:'0.5rem'}}
                        >
                        {imgurl?.length >= 1 ? null : uploadButton}
                        </Upload>
                </Row>

      </Form.Item>

      
      <Form.Item
        label=" Sub title"
        name="sub_title"
      >
        <Input className=" text-capitalize"  />

      </Form.Item>

      <Form.Item label = "Event Start Date"
                 name = "date">

        <DatePicker picker="date"  />
      </Form.Item>
      
     
        <Form.Item
        label="Description"
        name="description"
        
      >
         <ReactQuill 
         theme="snow" 
         value={event} 
         modules={modules}
         formats={formats}
         onChange={setEvent} />

      </Form.Item> 
     
 
      <Button style={{marginLeft:'350px',marginBottom:'25px'}} onClick={() => setVisibleEdit(true)}  >
                Edit Image Gallery Images
        </Button>


        <Button style={{marginLeft:'350px',marginBottom:'25px'}} onClick={() => setFeatureImageEdit(true)}  >
                Edit Press Gallery Images
        </Button>


 

  
     

 


      <Form.Item {...tailLayout}>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form> 
    </div>


    <ModalForm 
          isVisible={visibleEdit} 
          title="Add Event Gallery Images"
          footer={false}
          className=" pl-6"
          width="82%"
          cancel={()=>setVisibleEdit(!visibleEdit)}
          >
          <div>
            <div>
            {
               currentevents &&  <EventTable isLoading={false} data={eventimage} deleteEvent ={handleClickDelete}/>
            }
            </div>
            {!(addField) && <Button
              type="dashed"
              onClick={add}
              block
              icon={<PlusOutlined />}
            >
              Add Event Gallery
            </Button>}
            

            {
              addField && 
              <Form
            // cancel={cancel}
        form={form2}
        name="basic"
        initialValues={{ remember: true }}
        onFinish={onAddPart}
        onFinishFailed={onFinishFailed}
        >
            <Space
                  style={{ display: "flex", justifyContent :'space-around', marginBottom: 1 }}
                  align="baseline"
                >
                  <div className=' flex flex-col'>
        <Form.Item
        label={<p className="text-left text-indigo-800 m-0 ml-2 text-4xl ">Event Image</p>}
            name= "image"
            >   
              {/* <Button><Upload fileList = {fileList} onChange={ uploadFile}>Image</Upload></Button> */}
              
              
         
            {/* <Col span={5}>
                {

                eventimage?.map((img, i)=>{

                  return <div className="imglist" style={{height:"100px"}}>
                   
                  <Image    
                   preview={false}               
                   key={i}
                   style={{height:"100%", width:"100%", borderRadius: '0.25rem', display:'block', objectFit:'cover'}}
                   src={img?.image}
                   placeholder={<Loader/> }              
                 />   

                  <h2 onClick={(e)=>removeeventImage(e,img?.image,eId)} className=" text-black  "> <MdDelete/></h2> 

                    </div>
                })
              }
              </Col> */}
              

                <Button><Upload fileList = {fileList} onChange={ uploadFile}>Upload Event Image</Upload></Button>

                
                </Form.Item>
                </div>
 
              <Form.Item
                    name= "caption"
                    rules={[{ required: true, message: 'required!'}]}>
                   <Input onChange={(e)=>onEventCaption(e,eId)} placeholder="Caption"  style={{ width: '180px' }}/>
              </Form.Item>
             <div>
                  {  <MinusCircleOutlined  onClick={removeEvent}/>}
                </div>
                </Space>
              <Form.Item className="text-right">
                        <Button type="primary" id='draftbtn' className='w-36 mx-6' htmlType="submit">
                              {button === 'save' ? 'Save' : 'Update' }
                        </Button>
              </Form.Item>
              
        </Form>
               
              
 
               
            }
            {!(addField) &&  <div className='text-right mt-2'> 
{/* <Button id='orthobtn' className='w-36 mx-2 rounded'onClick={()=>setVisibleEdit(false)} >Cancel</Button> */}
<Button type="primary" id='draftbtn' className='w-36 mx-6' onClick={()=>setVisibleEdit(false)}>Submit</Button>
</div>
}
          </div>
             
        </ModalForm>



        <ModalForm 
        isVisible={visibleFeatureImageEdit}
        title="Add Press Release Images"
        footer={false}
          className=" pl-6"
          width="82%"
          cancel={()=>setFeatureImageEdit(!visibleFeatureImageEdit)}
          >

            <div>
            {
               currentevents && <PressRelease isLoading={false} data={FeaturedImage} deleteEvent ={handleClickPressDelete}/> 
            }
            </div>
            {!(addPressReleaseField) && <Button
              type="dashed"
              onClick={addPressReleaseImage}
              block
              icon={<PlusOutlined />}
            >
              Add Press Release Images
            </Button>}

            {
              addPressReleaseField &&
               <Form form = {form3}
               name="basic"
                initialValues={{ remember: true }}
                onFinish={onAddPressRelease}
                onFinishFailed={onFinishFailed}>

                  <Space
                  style={{ display: "flex", justifyContent :'space-around', marginBottom: 1 }}
                  align="baseline"
                >
                  <div className=' flex flex-col'>
              <Form.Item
                  label={<p className="text-left text-indigo-800 m-0 ml-2 text-4xl ">Event Image</p>}
                  name= "image"
                  >   
                <Button><Upload fileList = {fileList} onChange={ uploadPressReleaseFile}>Upload Press Release Image</Upload></Button>

                  </Form.Item>
                  </div>

                  <Form.Item
                    name= "caption"
                    rules={[{ required: true, message: 'required!'}]}>
                   <Input onChange={(e)=>onPressReleaseCaption(e,pId)} placeholder="Caption"  style={{ width: '180px' }}/>
              </Form.Item>
              <div>
                  {  <MinusCircleOutlined  onClick={removePressReleaseEvent}/>}
                </div>
                </Space>
                <Form.Item className="text-right">
                        <Button type="primary" id='draftbtn' className='w-36 mx-6' htmlType="submit">
                              {PressButton === 'save' ? 'Save' : 'Update' }
                        </Button>
              </Form.Item>
                  </Form>
              }

{!(addPressReleaseField) &&  <div className='text-right mt-2'> 
{/* <Button id='orthobtn' className='w-36 mx-2 rounded'onClick={()=>setVisibleEdit(false)} >Cancel</Button> */}
<Button type="primary" id='draftbtn' className='w-36 mx-6' onClick={()=>setFeatureImageEdit(false)}>Submit</Button>
</div>
}

            </ModalForm>

                 
</FormWrap>
    )
}



const FormWrap = styled.div`
position: relative;

.imglist {
overflow: hidden;
background-color: #f1f1f1;
text-align: center;
${'' /* border:1px solid black; */}



h2 { opacity : 0;
display:none;
position: absolute;
margin: 0;
bottom: 1%;
background-color: rgba(0,0,0,0.5);
cursor: pointer;
transition: 0.1s;

&:hover {

font-size: 1.5rem;
}

}

&:hover h2 {

opacity : 1;
display:block
}
}
`